const theme = {
    gridGutterWidth: 7, // obsolete, use em/rem instead
};
// Colors for CKEd toolbar comes from sass/themes/colors folder - main toolbar bgcolor
export const ckedUIColors = {
    black: 'var(--ckedui-dark)',
    blue1: 'var(--ckedui-blue1)',
    default: 'var(--color-gray-100)',
    green: 'var(--ckedui-green)',
    orange: 'var(--ckedui-orange)',
    pink: 'var(--ckedui-pink)'
};

export const attachmentsTypeNames = {
    archive: 'attach-archive',
    audio: 'attach-audio',
    database: 'attach-database',
    diskImage: 'attach-diskImage',
    document: 'attach-document',
    email: 'attach-email',
    event: 'attach-event',
    excel: 'attach-excel',
    file: 'attach-file',
    image: 'attach-image',
    link: 'attach-link',
    pdf: 'attach-pdf',
    presentation: 'attach-presentation',
    project: 'attach-project',
    sourceCode: 'attach-sourceCode',
    textDoc: 'attach-textDoc',
    video: 'attach-video',
    webPage: 'attach-web-page',
    youtube: 'attach-youtube',
    text: 'attach-text'
};

export default { ...theme, ckedUIColors };
